import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";

export default function Select(props) {

    const { 
        styles=null, 
        values='',
        setValues=() => {},
        selectData=[],
        selectClass='custom-select',
        subselectClass='',
        backgroundColors='',
        divwidth=null,
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();

    
    return (
        <div className={`${selectClass} ${subselectClass}`} style={ divwidth || {} }  >
            {styles ?
                <select onChange={(e) => { setValues(e.target.value);}} style={styles || {}}>
                    {selectData?.length > 0  && selectData?.map((x, i) => {
                        return (
                            <option key={i} value={x?.values} selected={`${values === x?.values ? 'selected' : ''}`}>{x?.labels}</option>        
                        );
                    })}
                </select>            
                :
                <select onChange={(e) => { setValues(e.target.value);}} style={{ background: backgroundColors }}>
                    {selectData?.length > 0  && selectData?.map((x, i) => {
                        return (
                            <option key={i} value={x?.values} selected={`${values === x?.values ? 'selected' : ''}`}>{x?.labels}</option>        
                        );
                    })}
                </select>            
            }
        </div>
    )    
}